import { setAlert } from "./alert";
import { isFunction } from "../../helpers";

import { history } from "../store";
import Axios from "axios";
import { SET_ERROR } from "../types";
import { shouldRedirectToLogin } from "../../helpers/authenticationRedirectPolicy";
import { reportFrontendError } from "../../../resources/js/core/utils/frontendErrorReporter";
export const handleError = (
    error,
    message,
    cb,
    cb_data,
    cb_link
) => async dispatch => {
    reportFrontendError(error, { source: "legacy", kind: "handled" });
    const timeout = /(timeout of ).+(ms exceeded)/i;
    const backend_timeout = /(Maximum execution time of).+(seconds exceeded)/i;
    try {
        if (error && error.hasOwnProperty('message')) {
            if (error.message === 'Request aborted') {
                return;
            }
        }
        if (process.env.NODE_ENV !== "test") {
            console.debug({
                msg: "Error Handler Error",
                error
            });
            console.debug({
                msg: "Error Handler Message",
                message
            });
        }

        //  Check for the existent of response object
        if (error && error.response) {
            console.log(error.response);

            switch (error.response.status) {
                case 401:
                case 419:
                    if (shouldRedirectToLogin(window.location.pathname)) {
                        if (window.trackerSessionTimeout) {
                            window.trackerSessionTimeout.expireSession();
                        }
                        else {
                            window.location.replace("/");
                        }
                    }
                    return;
                case 404:
                 
                    return history.push({
                        pathname: "/app/404",
                        state: { msg: "Page Not Found!" }
                    });
                case 422: {
                // Laravel Requests will return JSON response with validation
                // errors automatically. All Validation errors are 422, but
                // we also send back response 422 for some other alerts

                    // If the response has "errors" treat it like a validation message
                    if (!error.response.data.hasOwnProperty("errors")) {
                        break;
                    }

                    // Pull all validation errors from all fields to a single string for alert
                    let message = `${error.response.data.message} `;
                     
                    for (const field in error.response.data.errors) {
                        message +=
                        error.response.data.errors[field].join(" ") + " ";
                    }
                    dispatch(setAlert(message, "error"));
                }
                default:
                    break;
            }

            // DESC: If the error has a redirect
            if (error.response.data.hasOwnProperty("redirect_url")) {
                if (!error.response.data.redirect_url.startsWith("/app")) {
                    // DESC: browserHistory doesn't work for non-react routes
                     
                    return window.location.replace(
                        error.response.data.redirect_url
                    );
                }
                history.push(error.response.data.redirect_url);
            }

            if (error.response.data.hasOwnProperty("alert")) {
                let alert = error.response.data.alert;
                let isAnObject = typeof alert === "object";

                // DESC: The alert is either a string (msg) or object with more params
                let message = isAnObject ? alert.msg : alert;

                // DESC: The type is optional, otherwise determine based on status code
                let type =
                    isAnObject && alert.hasOwnProperty("type") ?
                        alert.type :
                        error.response.status < 300 ?
                            "success" :
                            "error";

                let timeout =
                    isAnObject && alert.hasOwnProperty("timeout") ?
                        alert.timeout :
                        type === "error" ?
                            false :
                            15000;
                dispatch(setAlert(message, type, timeout));
            }
            if (error.response.data.hasOwnProperty("msg")) {
                //  Pull msg out of resposne data
                Object.values(error.response.data.msg).forEach(msg => {
                    //  If msg contants an Array - Handle all items in the Array
                    //  Else Assuming is String, We'll set one alert
                    if (Array.isArray(msg)) {
                        msg.forEach(m => dispatch(setAlert(m, "error")));
                    }
                    else {
                        dispatch(setAlert(msg, "error"));
                    }
                });
            }

            if (error?.response?.config?.responseType === "blob") {
                const blobError = await error.response.data.text();
                const errObj = JSON.parse(blobError);
                if (
                    timeout.test(errObj.message) ||
                    backend_timeout.test(errObj.message)
                ) {
                    dispatch(
                        handleTimeout(error, message, cb, cb_data, cb_link)
                    );
                }
                else if (cb) {
                    dispatch(
                        handleTimeout(error, message, cb, cb_data, cb_link)
                    );
                }
                else {
                    dispatch(setAlert(errObj.msg || errObj.message, "error"));
                }
            }
        }
        else if (
            timeout.test(error.message) ||
                backend_timeout.test(error.message)
        ) {
            dispatch(handleTimeout(error, message, cb, cb_data, cb_link));
        }
        else {
            dispatch(setAlert(error.message, "error"));
        }
    }
    catch (errorError) {
        console.debug(
            { exception: "handleError error!" },
            { error },
            { errorError }
        );
        dispatch(writeToBugTable({ error: errorError }));
    }
    finally {
        if (shouldWriteToBugTable(error)) {
            dispatch(writeToBugTable({
                error,
                message,
                cb,
                cb_data
            }));
        }
    }
};

const shouldWriteToBugTable = error => {
    if (!error?.response) {
        return true;
    }

    return ![401, 403, 419, 422].includes(error.response.status);
};

const handleTimeout = (
    error,
    message,
    cb,
    cb_data,
    cb_link
) => async dispatch => {
    try {
        if (message) {
            if (isFunction(cb)) {
                dispatch(cb(cb_data, cb_link));
            }
            else {
                await dispatch(setAlert(message, "info"));
            }
        }
        else {
            await dispatch(
                setAlert("Request Time out. Please try again later", "error")
            );
        }
    }
    catch (errorError) {
        console.debug(
            { exception: "handleError error!" },
            { error },
            { errorError }
        );
        dispatch(writeToBugTable({ error: errorError }));
    }
};

const writeToBugTable = ({ error }) => async dispatch => {
    try {
        let bugs = { caller: "Unknown" };
        /*
            Instance properties

            Error.prototype.message
            Error message.

            Error.prototype.name
            Error name.

            Error.prototype.description
            A non-standard Microsoft property for the error description. Similar to message.

            Error.prototype.number
            A non-standard Microsoft property for an error number.

            Error.prototype.fileName
            A non-standard Mozilla property for the path to the file that raised this error.

            Error.prototype.lineNumber
            A non-standard Mozilla property for the line number in the file that raised this error.

            Error.prototype.columnNumber
            A non-standard Mozilla property for the column number in the line that raised this error.

            Error.prototype.stack
            A non-standard Mozilla property for a stack trace.

         */

        /*
            Error types
            Besides the generic Error constructor, there are seven other core error constructors in JavaScript. For client-side exceptions, see Exception handling statements.

            EvalError
            Creates an instance representing an error that occurs regarding the global function eval().

            InternalError
            Creates an instance representing an error that occurs when an internal error in the JavaScript engine is thrown. E.g. "too much recursion".

            RangeError
            Creates an instance representing an error that occurs when a numeric variable or parameter is outside of its valid range.

            ReferenceError
            Creates an instance representing an error that occurs when de-referencing an invalid reference.

            SyntaxError
            Creates an instance representing a syntax error.

            TypeError
            Creates an instance representing an error that occurs when a variable or parameter is not of a valid type.

            URIError
            Creates an instance representing an error that occurs when encodeURI() or decodeURI() are passed invalid parameters.
         */

        if (error instanceof EvalError) {
            bugs.type = "EvalError";
        }
        else if (error instanceof RangeError) {
            bugs.type = "RangeError";
        }
        else if (error instanceof ReferenceError) {
            bugs.type = "ReferenceError";
        }
        else if (error instanceof SyntaxError) {
            bugs.type = "SyntaxError";
        }
        else if (error instanceof TypeError) {
            bugs.type = "TypeError";
        }
        else if (error instanceof URIError) {
            bugs.type = "URIError";
        }
        else {
            bugs.type = "Request Error";
        }

        if (error?.response) {
            bugs.name =
                error.response?.data?.alert?.msg +
                ": " +
                error.response.statusText;
            bugs.action = error.response.config.method;
            bugs.module = error.response.request.responseURL;
            bugs.module_id =
                "READY STATE :" + error.response.request.readyState;
            bugs.metadata = error.response.request.response;
            bugs.caller = error.response.config.url || "url not found";
        }
        else {
            const jsonStack = error.stack?.split(" at ");
            bugs.name = error.name + ": " + error.message;
            bugs.action = "Front-End";

            let module;
            if (typeof jsonStack === "object") {
                module = jsonStack.find(stack => stack.includes("tryCatch"));
                if (!module) {
                    module = "Unknown tryCatch";
                }
            }
            else {
                module = "Unknown tryCatch";
            }
            bugs.module = module;

            bugs.module_id =
                typeof jsonStack === "object" ?
                    jsonStack.find(stack =>
                        stack.includes("Generator.invoke")
                    ) :
                    "Unknown invoker";
            bugs.metadata = jsonStack?.toString();
            let caller;
            if (typeof jsonStack === "object") {
                caller = jsonStack.find(stack => stack.includes("_callee"));
                if (!caller) {
                    caller = "Unknown Callee";
                }
            }
            else {
                caller = "Unknown Callee";
            }
            bugs.caller = caller;
        }

        /*
         SCHEMA
            'type' => String,
            'action' => String,
            'module' => String,
            'module_id' => String,
            'metadata' => String,
            'changes' => String,
            'acting_user' => String,
            'ip_address' => String,
            'occurred_at' => String,
            'caller' => String
         */

        dispatch({
            type: SET_ERROR,
            payload: JSON.stringify(bugs)
        });

        await Axios.post("/bugs/write", bugs);
    }
    catch (error) {
        if (process.env.NODE_ENV !== "test") {
            console.debug({ error });
        }
    // dispatch(handleError(error));
    }
};

// EXTEND ERROR
/*
    function MyError(message) {
        this.name = 'MyError';
        this.message = message;
        this.stack = (new Error()).stack;
    }
    MyError.prototype = new Error;  // <-- remove this if you do not
                                    //     want MyError to be instanceof Error
 */
